import type { ReactNode } from 'react';

interface SectionHeadingProps {
  index: string;
  title: string;
  desc?: ReactNode;
}

export default function SectionHeading({ index, title, desc }: SectionHeadingProps) {
  return (
    <div className="mb-8 border-b border-background-200 pb-5">
      <p className="font-label text-[11px] uppercase tracking-[0.35em] text-accent-700">{index}</p>
      <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {desc ? <p className="mt-2.5 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p> : null}
    </div>
  );
}